import moment from "moment";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Logo from "../../assets/appImages/app-logo.png";
import { FactureEmise, ModelDevis, UserInfos } from "../../redux/types";
import { factureListner } from "../../utils/api/user.api";
import {
  downloadOneDocument,
  useDocumentsDownload,
} from "../../utils/download-documents";
import { generateFacture } from "./devis-generator";
import "./guest.css";
const ShowFacture = () => {
  const [doc, setDoc] = useState<{
    facture: FactureEmise;
    model: ModelDevis;
    user: UserInfos;
  }>();
  const params = useParams<{ id: string }>();
  const [date, setDate] = useState(moment().format("DD/MM/YYYY"));
  const { isDownloading, run } = useDocumentsDownload();
  const getData = (id: string) => {
    setDoc(undefined);
    factureListner(id).then((res) => {
      if (res) {
        if (res.facture.date_facture) {
          setDate(res.facture.date_facture);
        }
        setDoc({
          facture: res.facture,
          // @ts-ignore
          model: res.model,
          user: res.user,
        });
      }
    });
  };

  useEffect(() => {
    if (params.id) {
      getData(params.id);
    }
  }, []);
  return (
    <div>
      <div className="text-center bg-primary py-3">
        <img src={Logo} alt="Logo" className="logo-app" />
      </div>
      {!doc && (
        <div className="text-center">
          <span
            className="spinner-border spinner-border-sm text-light me-1 d-inline-block"
            role="status"
          ></span>
          <span>Chargements</span>
        </div>
      )}
      {!!doc && (
        <div className="container">
          <div className="row mt-2">
            <div className="col-md-4"></div>

            <div className="col-md-4 col-sm-12 my-2">
              <div className="row">
                <div className="col-md-12 col-sm-12 my-2">
                  <p className="my-2">
                    Télécharger la facture{" "}
                    {doc.facture.statut === "Signé" ? "signé" : ""}
                  </p>
                  <button
                    className="btn w-100 text-white bg-primary"
                    type="submit"
                    disabled={isDownloading}
                    onClick={() =>
                      // La génération du PDF est comprise dans l'attente : le
                      // bouton reste occupé jusqu'à l'enregistrement.
                      run(async () => {
                        if (!doc.facture.file) {
                          await generateFacture(
                            doc.facture,
                            doc.model,
                            doc.user,
                            "",
                            date,
                          );
                        }
                        await downloadOneDocument(
                          `https://api.fastfacture.com/api/generate-pdf?uid=${doc.facture.id}`,
                          `Facture ${doc.facture.numero}`,
                        );
                      })
                    }
                  >
                    {isDownloading ? "Téléchargement…" : "Télécharger"}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShowFacture;
